export default __webpack_public_path__ + "static/media/EM1920.34I-42948_-25691_0.f237b632.jpg";